import { PointData, Point as PointType, StageData, Stage as StageType, Trail, Action as ActionType, TrailData, ActionData } from "./types";

export class Internalisation implements Trail {
  public readonly dataType = 'trail';
  protected _points: Trail['points'];
  protected _stages: Stage[];
  constructor(
    points: Trail['points'] = [],
    trail: Stage[] = [],
  ) {
    this._points = points;
    this._stages = trail;
  }
  get points(): Trail['points'] {
    return this._points;
  }
  get trail(): Stage[] {
    return this._stages;
  }
  addPoint(point: Point): this {
    this._points.push(point);
    return this;
  }

  addStage(stage: Stage): void {
    this._stages.push(stage);
  }

  getStageById(id: string): Stage | undefined {
    return this._stages.find((stage) => stage.id === id);
  }

  static fromData(data: Trail): Internalisation {
    return new Internalisation(data.points, data.trail.map(stage => Stage.fromData(stage)));
  }

  toData(): TrailData {
    return {
      points: this._points,
      trail: this._stages.map(stage => stage.toData())
    }
  }
}

export class Stage implements StageType {
  protected _actions: Array<Action|Point> = []
  public readonly dataType: 'stage' = 'stage';
  
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly description: string = '',
  ) {}

  get actions(): Array<Action|Point> {
    return this._actions;
  }

  addAction(action: Action): void {
    this._actions.push(action);
  }

  addPoint(point: Point): void {
    this._actions.push(point)
  }

  getActionOrPointById(id: string): Action | Point | undefined {
    return this._actions.find((action) => action.id === id);
  }

  toData(): StageData {
    return {
      id: this.id,
      title: this.title,
      description: this.description,
      actions: this._actions.map((action) => action.toData())
    }
  }

  static fromData(data: StageData): Stage {
    const stage = new Stage(data.id, data.title, data.description);
    stage._actions = data.actions?.map((action) => {
      if (action.dataType === 'action') {
        return Action.fromData(action);
      }
      return Point.fromData(action);
    }) ?? [];
    return stage;
  }
}

export class Action implements ActionType {
  public readonly dataType = 'action';
  protected _points: Point[] = [];
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly description: string = '',
  ) {}

  addPoint(point: Point): void {
    this._points.push(point);
  }

  get points(): Point[] {
    return this._points;
  }

  toData(): ActionData {
    return {
      dataType: 'action',
      id: this.id,
      title: this.title,
      description: this.description,
      points: this._points.map((point) => point.toData())
    }
  }

  static fromData(data: ActionData): Action {
    const action = new Action(data.id, data.title, data.description);
    action._points = data.points.map((point) => new Point(point.id, point.value)) ?? [];
    return action;
  }
}

export class Point implements PointType {
  public readonly dataType = 'point';
  constructor(
    public readonly id: string,
    public readonly value: string,
  ) {}

  toData(): PointData {
    return this;
  }
  
  static fromData(data: PointData): Point {
    return new Point(data.id, data.value);
  }
}

